import { Controller } from "stimulus";
const getClosest = require("../utils/get-closest");

export default class extends Controller {
  static values = {
    initialLimit: Number,
    max: Number,
  };
  static targets = [
    "increaseMessage",
    "increaseValue",
    "decreaseMessage",
    "decreaseValue",
    "sameMessage",
    "unsetMessage",
    "maxMessage",
    "saveButton",
  ];

  limitChanged({ target }) {
    this.resetState();

    const newValue = parseInt(target.value);

    // The max-value check is a validation constraint independent of any
    // prior override, so it always applies - regardless of whether there
    // was an existing override to react to.
    if (this.maxValue !== 0 && newValue > this.maxValue) {
      this.toggleMessage(this.maxMessageTarget, true);
      this.saveButtonTarget.disabled = true;
      return;
    }

    // Nothing to compare the new value against, so none of these reactive
    // messages (unset/increase/decrease/same) apply - only show them once
    // there's an existing override to react to.
    if (Number.isNaN(this.initialLimitValue)) {
      return;
    }

    let message;
    if (Number.isNaN(newValue)) {
      message = this.unsetMessageTarget;
    } else if (newValue > this.initialLimitValue) {
      message = this.increaseMessageTarget;
      this.showNewLimit(this.increaseValueTarget, newValue);
    } else if (newValue < this.initialLimitValue) {
      message = this.decreaseMessageTarget;
      this.showNewLimit(this.decreaseValueTarget, newValue);
    } else {
      message = this.sameMessageTarget;
    }
    this.toggleMessage(message, true);
  }

  toggleMessage(el, show) {
    el.classList.toggle("flex", show);
    el.classList.toggle("dn", !show);
  }

  showNewLimit(el, value) {
    el.innerText = value.toLocaleString();
  }

  resetState() {
    [
      this.increaseMessageTarget,
      this.decreaseMessageTarget,
      this.sameMessageTarget,
      this.unsetMessageTarget,
      this.maxMessageTarget,
    ].forEach((el) => {
      this.toggleMessage(el, false);
    });
    this.saveButtonTarget.disabled = false;
  }
}
